import { render, staticRenderFns } from "./flipswitch.vue?vue&type=template&id=4bcb0de2&lang=html&"
import script from "./flipswitch.vue?vue&type=script&lang=js&"
export * from "./flipswitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports